require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-yarrabend-site-update.json") })
        }
      }, "path---news-yarrabend-site-update");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-yarrabend-site-update!./.cache/json/news-yarrabend-site-update.json
// module id = 872
// module chunks = 231608221292675